import GradientContainer from "@app/components/gradient/gradient-container";
import Icon from "@mdi/react";
import { mdiNumericPositive1 } from "@mdi/js";
import { useThemeContext } from "@app/contexts/theme-context";

const EmployeesSectionBottomContent = () => {
  const { isMobile } = useThemeContext();
  return (
    <div className="grid grid-cols-12 w-full gap-y-8">
      {!isMobile && <div className="md:col-span-1" />}
      <div className="col-span-12 md:col-span-5 flex flex-row items-center justify-end">
        <div className="md:w-[560px] flex flex-col space-y-4">
          <GradientContainer overrideClassName="p-3 mb-2 w-12 rounded-full shadow-outer-secondary">
            <Icon size={1} path={mdiNumericPositive1} />
          </GradientContainer>
          <span className="mobile-h4 md:h5 lg:h4">Join with SimpleWaste</span>
          <span className="text-body-lg">
            We understand that selecting the right company to sell your business
            to can be a very personal and challenging decision. Part of our
            pathway to success has been to procure businesses whose ownership is
            looking for a seamless and graceful exit strategy. SimpleWaste
            provides unparalleled advantages for owners who are considering
            selling their business.​
          </span>
        </div>
      </div>
      {!isMobile && <div className="col-span-1" />}
      <div className="col-span-12 md:col-span-5">
        <div
          className="min-h-[512px] h-full w-full bg-cover bg-top bg-no-repeat
          rounded-xl md:rounded-tr-none md:rounded-br-none md:rounded-tl-xl md:rounded-bl-xl"
          style={{
            backgroundImage:
              "url('/images/acquisitions/employees-section-2.png')",
          }}
        />
      </div>
    </div>
  );
};

export default EmployeesSectionBottomContent;
